import React, { createContext, useContext } from 'react';
const BrandContext = createContext();

export const useBrand = () => useContext(BrandContext);

export const BrandProvider = ({ brand, children }) => (
  <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
);
